// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ab5eadd8","239":"c225f2de","455":"79b72ad9","488":"d0c3ceea","977":"b7dfd29c"}[chunkId] + ".chunk.js";
};